import _isEmpty from 'lodash/isEmpty';
import collisionsWorkPeriodTemplate from './../collisions-work-period/collisions-work-period.html';

export default class EditWorkPeriodController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    moment,
    EmployeeService,
    UtilService,
    workPeriod
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.EmployeeService = EmployeeService;
    this.UtilService = UtilService;
    this.workPeriod = workPeriod;

    this.startDate = this.moment(this.workPeriod.startDate).toDate();
    this.endDate = this.moment(this.workPeriod.endDate).toDate();
    if (this.workPeriod.startTime) {
      this.startTime = this.moment(this.UtilService.parseTime(this.workPeriod.startTime)).format('HH:mm');
    }

    if (this.workPeriod.endTime) {
      this.endTime = this.moment(this.UtilService.parseTime(this.workPeriod.endTime)).format('HH:mm');
    }

    this.weekdays = this.UtilService.getAllWeekDays();
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  delete() {
    this.EmployeeService.deleteWorkPeriod(this.workPeriod.employeeId, this.workPeriod.id)
      .then(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Usunięto wpis seryjny.')
            .position('bottom right')
            .hideDelay(3000)
        );
        this.$mdDialog.hide();
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  update(form = {}) {
    if (form.$invalid) {
      return false;
    }

    this.workPeriod.startDate = this.moment(this.startDate).format('YYYY-MM-DD');
    this.workPeriod.endDate = this.moment(this.endDate).format('YYYY-MM-DD');
    this.workPeriod.startTime = this.startTime;
    this.workPeriod.endTime = this.endTime;
    this.EmployeeService.editWorkPeriod(this.workPeriod.employeeId, this.workPeriod)
      .then(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Edytwano wpis seryjny.')
            .position('bottom right')
            .hideDelay(3000)
        );
        return this.$mdDialog.hide();
      }).catch(error => {
        if (!_isEmpty(error.WorkDaysCannotBeEdited) || !_isEmpty(error.WorkDaysCannotBeRemoved)) {
          const collisionsDialog = this.$mdDialog.confirm({
            multiple: true,
            bindToController: true,
            controllerAs: 'ctrl',
            controller: 'CollisionsWorkPeriodController',
            template: collisionsWorkPeriodTemplate,
            locals: {
              error
            },
            clickOutsideToClose: true
          });
          this.$mdDialog.show(
            collisionsDialog
          ).then(skipDates => {
            if (skipDates) {
              this.workPeriod.skipDates = skipDates;
              this.update();
            }
          });
        } else {
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          );
        }
      });
  }
}
